export const SET_PARAMETER = 'SET_PARAMETER';
